// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Form__Status from "./Form__Status.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactDomElement from "../../primitives/ReactDomElement.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactUpdateDebounced from "../../primitives/ReactUpdateDebounced.res.js";

function Make(Params) {
  let Form__Elements__Accessibility$Make$ControlEnterKey = props => {
    let onSubmitRequested = props.onSubmitRequested;
    let ref = React.useRef(null);
    let match = Params.useSubmit(props.onSubmit);
    let onSubmit = match.onSubmit;
    let disabled = match.disabled;
    let onKeyDown = React.useCallback(evt => {
      let match = evt.key;
      if (match !== "Enter") {
        return;
      }
      if (disabled) {
        return;
      }
      let htmlDocument = document;
      let parentDomElement = Stdlib_Option.flatMap(ReactDomElement.fromRef(ref), prim => Primitive_option.fromNullable(prim.parentElement));
      let match$1 = htmlDocument.activeElement;
      if (parentDomElement !== undefined && !(match$1 == null)) {
        Array.prototype.slice.call(Primitive_option.valFromOption(parentDomElement).getElementsByTagName("input")).forEach(inputNode => {
          if (inputNode === match$1) {
            Stdlib_Option.forEach(onSubmitRequested, onSubmitRequested => onSubmitRequested());
            return onSubmit();
          }
        });
        return;
      }
    }, [disabled]);
    React.useEffect(() => {
      let domElement = document;
      domElement.addEventListener("keydown", onKeyDown);
      return () => {
        domElement.removeEventListener("keydown", onKeyDown);
      };
    }, [ref]);
    return JsxRuntime.jsx("div", {
      ref: Primitive_option.some(ref)
    });
  };
  let ControlEnterKey = {
    make: Form__Elements__Accessibility$Make$ControlEnterKey
  };
  let Form__Elements__Accessibility$Make$AutoSave = props => {
    let __delay = props.delay;
    let __disabled = props.disabled;
    let disabled = __disabled !== undefined ? __disabled : false;
    let delay = __delay !== undefined ? __delay : 750;
    let match = Params.useSubmit(props.onSubmit);
    let onSubmit = match.onSubmit;
    let submitDisabled = match.disabled;
    let status = Params.useFormStatus();
    let values = Params.useFormValues();
    let debouncedValues = ReactUpdateDebounced.use(values, delay);
    ReactUpdateEffect.use1(() => {
      if (Form__Status.isValid(status) && !submitDisabled && !disabled) {
        onSubmit();
      }
    }, [debouncedValues]);
    return null;
  };
  let AutoSave = {
    make: Form__Elements__Accessibility$Make$AutoSave
  };
  return {
    ControlEnterKey: ControlEnterKey,
    AutoSave: AutoSave
  };
}

let Status;

let Submission;

export {
  Status,
  Submission,
  Make,
}
/* react Not a pure module */
